module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.13-79.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.13.md
// module id = 496
// module chunks = 352